// The public asset is published from config/plans by publish-public-plans.cjs.
// No mock prices, browser discount calculations, or private Firebase reads.
export async function readPublicPlans(signal) {
  const response = await fetch(`${process.env.PUBLIC_URL || ""}/axoris-plans.json`, { signal, cache: "no-cache" });
  if (response.status === 404) return null;
  if (!response.ok) throw new Error("public-prices-unavailable");
  const body = await response.text();
  if (!body.trim()) return null;
  const plans = JSON.parse(body);
  const positive = (value) => Number.isSafeInteger(value) && value > 0;
  if (plans.schemaVersion !== 1 || plans.source !== "config/plans" || plans.currency !== "IDR"
    || !positive(plans.monthly) || !positive(plans.annual) || !positive(plans.perMonth)
    || !Number.isSafeInteger(plans.saving) || plans.saving < 0) {
    throw new Error("public-prices-invalid");
  }
  return plans;
}
